import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

/**
 * Criação da instância do Pinia para gerenciamento de estado global
 * Esta instância será configurada com plugins e middlewares necessários
 */
const pinia = createPinia()

/**
 * Configuração do plugin de persistência
 * Só é ativado no ambiente do navegador para evitar erros durante SSR
 * Este plugin permite que os estados sejam persistidos no localStorage
 */
if (typeof window !== 'undefined') {
    pinia.use(piniaPluginPersistedstate)
}

/**
 * Configuração do middleware global do Pinia
 * Adiciona funcionalidades de debug e logging em desenvolvimento
 */
pinia.use(({ store }) => {
    // Intercepta todas as ações da store para logging em desenvolvimento
    store.$onAction(({ name, store: targetStore }) => {
        if (process.env.NODE_ENV === 'development') {
        }
    })

    // Adiciona flag de debug apenas em desenvolvimento
    return {
        debug: process.env.NODE_ENV === 'development',
    }
})

export default pinia
